import {Player} from '@wix/music-player';
import {Observable} from 'rxjs';

export const documentVisible = () => {
  return new Observable((subscriber) => {
    onDocumentVisible(() => {
      subscriber.next('visible');
      subscriber.complete();
    });
  });
};
export const onPlayerRendered = (player: Player) => {
  return new Observable((subscriber) =>
    player.onNextFrame(() => {
      subscriber.next('visible');
      subscriber.complete();
    }),
  );
};

function onDocumentVisible(cb: () => void) {
  requestAnimationFrame(() => {
    // #MUS-1109 Because of some reason cb fires when widget is not visible.
    // And also calls when widget is on invisible page in viewer.
    const {width, height, left, right, top, bottom}: ClientRect | DOMRect = document.body.getBoundingClientRect();
    if (width === 0 && height === 0 && left === 0 && right === 0 && top === 0 && bottom === 0) {
      // browser gives animation frame but in iframe is not visible.
      setTimeout(() => onDocumentVisible(cb), 200);
    } else {
      cb();
    }
  });
}
